import React from 'react';
import AgreementComponent from './AgreementComponent';

const DPAComponent = ({ form, currentStatus, showTitle = true, organisation = null, onSaveChanges = null, loading = false }) => {
  // Default DPA JSON structure
  const defaultDPAStructure = {
    processing: {
      lawfulBasis: false,
      purposeLimitation: false,
      dataMinimisation: false,
      accuracy: false,
      storageLimitation: false,
      securityMeasures: false
    },
    rights: {
      rightToInformation: false,
      rightOfAccess: false,
      rightToRectification: false,
      rightToErasure: false,
      rightToRestrictProcessing: false,
      rightToDataPortability: false,
      rightToObject: false
    },
    security: {
      technicalMeasures: false,
      organisationalMeasures: false,
      staffTraining: false,
      incidentReporting: false,
      regularReviews: false
    }
  };

  return (
    <AgreementComponent
      form={form}
      currentStatus={currentStatus}
      agreementType="dpa"
      title="Data Processing Agreement (DPA)"
      description="GDPR compliance and data processing responsibilities"
      defaultStructure={defaultDPAStructure}
      showTitle={showTitle}
      organisation={organisation}
      onSaveChanges={onSaveChanges}
      loading={loading}
    />
  );
};

export default DPAComponent;
